import React, { useState, useEffect, useContext } from 'react'
import './rightBar.css'
import { HeroData } from '../heropage/buildsys'
import { api } from '../network/api'
import Auth from './AuthBar'
import Cookies from 'js-cookie'
import { GiCutDiamond } from "react-icons/gi"
import { UserDataContext } from '../auth'
import { MissionData } from '../missionpage/missionsys'
import { Button, Collapse, Dialog, DialogContent, DialogTitle, InputAdornment, List, ListItem, ListItemText, TextField, Typography } from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { CompName, GameDataContext } from '../game'
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'
import Markdown from 'react-markdown'

const Sidebar = () => {
    const ctx = useContext( UserDataContext )
    if ( !ctx ) {
        throw new Error( 'useUserData must be used within a UserDataProvider' )
    }
    return (
        <div className="sidebar">
            <ul>
                <li key="auth" className='subbar' style={ { display: !ctx.userData ? 'block' : 'none' } }><Auth /></li>
                <li key="account" className='subbar' style={ { display: ctx.userData ? 'block' : 'none' } }><AccountInfo /></li>
                { ctx.userData && ctx.heroData && <li key="hero" className='subbar' ><HeroInfo /></li> }
                { ctx.userData && ctx.heroData && <li key="dungeon" className='subbar' ><DungeonInfo /></li> }
                { ctx.userData && ctx.heroData && <li key="team" className='subbar' ><TeamInfo /></li> }
            </ul>
        </div>
    )
}

export default Sidebar

function AccountInfo () {
    const ctx = useContext( UserDataContext )
    if ( !ctx ) {
        throw new Error( 'useUserData must be used within a UserDataProvider' )
    }
    if ( !ctx.userData ) {
        return ( <h1>请登录！</h1> )
    }
    // 获取当前时间
    const currentTime = new Date().toLocaleTimeString(
        navigator.language,
        {
            hour12: false,
            hour: 'numeric',
            minute: 'numeric',
        } )


    return (
        <div className="accountbar">
            <ul>
                <li><a href='#'>{ ctx.userData.name }</a></li>
                <li> <GiCutDiamond /> 0{/*todo:账号余额*/ }</li>
                <li>{ currentTime }</li>
            </ul>
        </div>
    )
};

function HeroInfo () {
    const ctx = useContext( UserDataContext )
    if ( !ctx ) {
        throw new Error( 'useUserData must be used within a UserDataProvider' )
    }
    const gamectx = useContext( GameDataContext )
    if ( !gamectx ) {
        throw new Error( 'GameDataContext must be used within a GameDataProvider' )
    }
    let heroData = ctx.heroData
    //const [ finalAddition, setFinalAddition ] = useState( heroData.FinalAddition )

    if ( !heroData || !ctx.userData ) {
        return <div>加载中...</div>
    }
    const heroName = heroData.name // 英雄名称
    const heroTitle = "The Great" // todo:英雄称号
    const race = heroData.race // 种族
    const profession = heroData.profession?.join( " " ) // 职业
    const level = heroData.level // 等级
    const currentExperience = heroData.Exp // 当前经验
    const currentHonor = 100 // todo:当前荣誉
    const currentMoney = heroData.money ?? 0 // 当前金钱（旧数据无 money 字段显示 0）

    return (
        <div>
            <ul>
                <li>
                    <div className="info-row">
                        <span>{ heroTitle }</span>
                        <a href='#'>{ heroName }</a>
                    </div>
                </li>
                <li>
                    <div className="info-row">
                        { gamectx.getName( CompName.race, race ) }
                        { ( heroData.profession ?? [] ).map( ( val ) => {
                            return gamectx.getName( CompName.profession, val )
                        } ) }
                    </div>
                </li>
                <li>
                    <div className="info-row">
                        <span>{ level } 级</span>
                        <span>经验: { currentExperience }</span>
                        { ctx.userData.role >= 1 && (
                            <SetEXP hid={ heroData.id } />
                        ) }
                    </div>
                </li>
                {/* 金额数字单独成元素（出售/回显测试按数字精确匹配），行文本保持"金钱: N"整行 */}
                <li>金钱: { currentMoney }<span style={ { display: 'none' } }>{ currentMoney }</span></li>
                <li>荣誉: { currentHonor }</li>
            </ul>
        </div>
    )
}

export interface SetEXPProps {
    hid: number
}
function SetEXP ( { hid }: SetEXPProps ) {
    const [ openDialog, setOpenDialog ] = useState( false )
    const [ newExperience, setNewExperience ] = useState( 0 )

    const handleOpenDialog = () => {
        setOpenDialog( true )
    }

    const handleCloseDialog = () => {
        setOpenDialog( false )
    }

    const handleSetExperience = () => {
        api.post( '/manager/setEXP/' + hid + '/' + newExperience )
            .then( response => {
                console.log( 'set exp to ' + newExperience + ' successfully' )
            } )
            .catch( error => {
                alert( 'Error set exp:' + error.response.data )
            } )
        handleCloseDialog()
    }

    return (
        <div>
            <Button variant="outlined" onClick={ handleOpenDialog }>
                设置经验
            </Button>
            <Dialog open={ openDialog } onClose={ handleCloseDialog }>
                <DialogTitle>设置经验值</DialogTitle>
                <DialogContent>
                    <TextField
                        label="经验值"
                        type="number"
                        value={ newExperience }
                        onChange={ ( e ) => setNewExperience( parseInt( e.target.value, 10 ) ) }
                    />
                    <Button variant="outlined" onClick={ handleSetExperience }>
                        确定
                    </Button>
                </DialogContent>
            </Dialog>
        </div>
    )
}

function DungeonInfo () {
    const ctx = useContext( UserDataContext )
    if ( !ctx ) {
        throw new Error( 'useUserData must be used within a UserDataProvider' )
    }
    const { heroData, teamData } = ctx
    const [ mission, setMission ] = useState<MissionData | null>()
    useEffect( () => {
        if ( teamData?.NextMissionID ) {
            api.get( `/component/mission/` + teamData?.NextMissionID )
                .then( response => {
                    const income: MissionData = response.data
                    console.log( income )
                    setMission( income )
                } )
                .catch( error => {
                    console.error( 'Error getting missions data:', error )
                } )
        }
    }, [ teamData?.NextMissionID ] )

    if ( !heroData || !teamData || !ctx.userData ) {
        return <div>加载中...</div>
    }
    const dungeonName = mission?.name || "闲逛中..." // 当前地城名称
    const settlementTime = new Date( teamData.NextMissionTime ).toLocaleTimeString(
        navigator.language,
        {
            hour12: false,
            hour: 'numeric',
            minute: 'numeric',
        } )// 当前地城结算时间
    const tactics =
        heroData.mission_strategy && heroData.mission_strategy[ teamData.NextMissionID ] !== undefined
            ? heroData.mission_strategy[ teamData.NextMissionID ]
            : heroData.default_strategy
    // 当前地城挂载的战术

    return (
        <div>
            <h3>当前地城：</h3>
            <ul>
                <li>
                    <div className="info-row">
                        <a href='#'>{ dungeonName }</a>
                        <Typography variant="body2">{ settlementTime }</Typography>
                        { ctx.userData.role >= 1 && (
                            <SetMissionTime tid={ teamData.ID } time={ new Date( teamData.NextMissionTime ) } />
                        ) }
                    </div></li>
                <li><a href='#'>{ tactics }</a></li>
            </ul>
        </div>
    )
}

export interface SetMissionTimeProps {
    tid: string
    time: Date
}
function SetMissionTime ( { tid, time }: SetMissionTimeProps ) {
    const [ openDialog, setOpenDialog ] = useState( false )
    const [ nextTime, setNextTime ] = useState<Dayjs | null>( dayjs( time ) )

    const handleOpenDialog = () => {
        setOpenDialog( true )
    }

    const handleCloseDialog = () => {
        setOpenDialog( false )
    }

    const handleSetExperience = () => {
        if ( nextTime == null ) {
            return
        }
        api.post( '/manager/setMissionTime/' + tid + '/' + nextTime.format( 'YYYY-MM-DDTHH:mm:ssZ' ) )
            .then( response => {
                console.log( 'set time to ' + nextTime + ' successfully' )
            } )
            .catch( error => {
                alert( 'Error set time:' + error.response.data )
            } )
        handleCloseDialog()
    }

    return (
        <div>
            <Button variant="outlined" onClick={ handleOpenDialog }>
                设置下次任务时间
            </Button>
            <Dialog open={ openDialog } onClose={ handleCloseDialog }>
                <DialogTitle>设置下次任务时间</DialogTitle>
                <DialogContent>
                    <LocalizationProvider dateAdapter={ AdapterDayjs }>
                        <DateTimePicker
                            value={ nextTime }
                            onChange={ newDate => setNextTime( newDate ) }
                            ampm={ false }
                            timeSteps={ { hours: 1, minutes: 1, seconds: 5 } }
                        />
                    </LocalizationProvider>
                    <Button variant="outlined" onClick={ handleSetExperience }>
                        确定
                    </Button>
                </DialogContent>
            </Dialog>
        </div>
    )
}


function TeamInfo () {
    const ctx = useContext( UserDataContext )
    if ( !ctx ) {
        throw new Error( 'useUserData must be used within a UserDataProvider' )
    }
    const { heroData, teamData } = ctx
    const [ members, setMembers ] = useState<HeroData[] | null>()

    useEffect( () => {
        if ( teamData ) {
            api.get( `/team/` + teamData.ID + `/members` )
                .then( response => {
                    const income = response.data
                    setMembers( income )
                } )
                .catch( error => {
                    console.error( 'Error getting members:', error )
                } )
        }
    }, [ teamData ] )

    if ( !heroData || !teamData || !members ) {
        return <div>加载中...</div>
    }

    return (
        <div>
            <h3>团队信息</h3>
            <ul>
                <li><a href='#'>{ teamData.Name }</a>：</li>
                <li>团金：{ teamData.Money }</li>
                <li><Markdown>{ teamData.Announcement }</Markdown></li>
                <li><details><summary>成员:</summary>
                    <ul><a href='#'>
                        { members.map( ( member, index ) => (
                            <li key={ index }>{ member.name }</li>
                        ) ) }
                    </a></ul>
                </details></li>
            </ul>
        </div>
    )
}
